import React from 'react';
import { Link } from 'react-router-dom';

import { Container, Code, Text, Button } from './style';

const Error404: React.FC = _ => {
  return (
    <Container>
      <Code>404</Code>
      <Text>존재하지 않는 페이지입니다</Text>

      <Link to="/">
        <Button>홈으로 이동</Button>
      </Link>
    </Container>
  );
};

export default Error404;
